import React, { useState } from "react";
import { Form, Button, Row, Col } from "react-bootstrap";

const TimeInput = ({ onTimeSubmit }) => {
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [direction, setDirection] = useState("forward"); // "forward" or "reverse"

  const handleSubmit = (e) => {
    e.preventDefault();
    if (direction === "forward" && startTime) {
      onTimeSubmit({ time: new Date(startTime), direction: "forward" });
    } else if (direction === "reverse" && endTime) {
      onTimeSubmit({ time: new Date(endTime), direction: "reverse" });
    }
  };

  return (
    <Form onSubmit={handleSubmit} className="mb-4">
      <Row className="align-items-end">
        <Col xs={12} md={4} className="mb-3">
          <Form.Group>
            <Form.Label>Calculation Direction</Form.Label>
            <Form.Select
              value={direction}
              onChange={(e) => setDirection(e.target.value)}
            >
              <option value="forward">Start Time → End Time</option>
              <option value="reverse">End Time → Start Time</option>
            </Form.Select>
          </Form.Group>
        </Col>
        <Col xs={12} md={5} className="mb-3">
          <Form.Group>
            <Form.Label>
              {direction === "forward"
                ? "When would you like to start?"
                : "When would you like to finish?"}
            </Form.Label>
            {direction === "forward" ? (
              <Form.Control
                type="datetime-local"
                value={startTime}
                onChange={(e) => setStartTime(e.target.value)}
                required
              />
            ) : (
              <Form.Control
                type="datetime-local"
                value={endTime}
                onChange={(e) => setEndTime(e.target.value)}
                required
              />
            )}
          </Form.Group>
        </Col>
        <Col xs={12} md={3} className="mb-3">
          <Button type="submit" variant="primary" className="w-100">
            Calculate Timeline
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default TimeInput;
